import { gql } from "@apollo/client"

export const MY_USER_SUBSCRIPTION = gql`
    subscription MyUserSubscription {
        myUser {
            hasMultipleSites
            sites {
                name
            }
        }
    }
`
